import React from 'react';
import { Card, CardBody, Flex, Box, Text, Spinner } from '@chakra-ui/react';
import { Users, Buildings } from 'phosphor-react';

interface PartnerSummaryCardsProps {
  totalPartners: number;
  totalEmpresas: number;
  totalEmpresasSimples: number;
  totalEmpresasPresumido: number;
  isLoading: boolean;
}

export function PartnerSummaryCards({
  totalPartners,
  totalEmpresas,
  totalEmpresasSimples,
  totalEmpresasPresumido,
  isLoading,
}: PartnerSummaryCardsProps) {
  // Calcular porcentagens em relação ao total de empresas
  const porcentagemSimples =
    totalEmpresas > 0 ? ((totalEmpresasSimples / totalEmpresas) * 100).toFixed(1) : '0.0';
  const porcentagemPresumido =
    totalEmpresas > 0 ? ((totalEmpresasPresumido / totalEmpresas) * 100).toFixed(1) : '0.0';

  return (
    <Flex
      direction={{ base: 'column', md: 'row' }}
      gap={4}
      mb={6}
      flexWrap="wrap"
      justify={{ base: 'center', lg: 'flex-start' }}
    >
      <Card shadow="sm" bg="white" borderRadius="lg" w={{ base: '100%', sm: '200px' }} maxW="200px">
        <CardBody py={3} px={4} position="relative">
          {isLoading ? (
            <Flex align="center" justify="center" h="50px">
              <Spinner size="sm" color="blue.500" />
            </Flex>
          ) : (
            <Flex align="center" gap={3}>
              <Box p={1.5} borderRadius="lg" bg="blue.50">
                <Users color="#3182CE" size={20} />
              </Box>
              <Box>
                <Text fontSize="xs" color="gray.500" fontWeight="medium" mb={0.5}>
                  Total de Socios
                </Text>
                <Text fontSize="lg" fontWeight="bold" color="gray.800">
                  {totalPartners}
                </Text>
              </Box>
            </Flex>
          )}
        </CardBody>
      </Card>

      <Card shadow="sm" bg="white" borderRadius="lg" w={{ base: '100%', sm: '200px' }} maxW="200px">
        <CardBody py={3} px={4} position="relative">
          {isLoading ? (
            <Flex align="center" justify="center" h="50px">
              <Spinner size="sm" color="purple.500" />
            </Flex>
          ) : (
            <Flex align="center" gap={3}>
              <Box p={1.5} borderRadius="lg" bg="purple.50">
                <Buildings color="#805AD5" size={20} />
              </Box>
              <Box>
                <Text fontSize="xs" color="gray.500" fontWeight="medium" mb={0.5}>
                  Total de Empresas
                </Text>
                <Text fontSize="lg" fontWeight="bold" color="gray.800">
                  {totalEmpresas}
                </Text>
              </Box>
            </Flex>
          )}
        </CardBody>
      </Card>

      <Card shadow="sm" bg="white" borderRadius="lg" w={{ base: '100%', sm: '200px' }} maxW="200px">
        <CardBody py={3} px={4} position="relative">
          {isLoading ? (
            <Flex align="center" justify="center" h="50px">
              <Spinner size="sm" color="yellow.500" />
            </Flex>
          ) : (
            <>
              <Flex align="center" gap={3}>
                <Box p={1.5} borderRadius="lg" bg="yellow.50">
                  <Buildings color="#D69E2E" size={20} />
                </Box>
                <Box flex={1}>
                  <Text fontSize="xs" color="gray.500" fontWeight="medium" mb={0.5}>
                    Simples Nacional
                  </Text>
                  <Text fontSize="lg" fontWeight="bold" color="gray.800">
                    {totalEmpresasSimples}
                  </Text>
                </Box>
              </Flex>
              {totalEmpresas > 0 && (
                <Text
                  fontSize="xs"
                  color="yellow.600"
                  fontWeight="semibold"
                  position="absolute"
                  bottom={2}
                  right={3}
                >
                  {porcentagemSimples}%
                </Text>
              )}
            </>
          )}
        </CardBody>
      </Card>

      <Card shadow="sm" bg="white" borderRadius="lg" w={{ base: '100%', sm: '200px' }} maxW="200px">
        <CardBody py={3} px={4} position="relative">
          {isLoading ? (
            <Flex align="center" justify="center" h="50px">
              <Spinner size="sm" color="teal.500" />
            </Flex>
          ) : (
            <>
              <Flex align="center" gap={3}>
                <Box p={1.5} borderRadius="lg" bg="teal.50">
                  <Buildings color="#319795" size={20} />
                </Box>
                <Box flex={1}>
                  <Text fontSize="xs" color="gray.500" fontWeight="medium" mb={0.5}>
                    Lucro Presumido
                  </Text>
                  <Text fontSize="lg" fontWeight="bold" color="gray.800">
                    {totalEmpresasPresumido}
                  </Text>
                </Box>
              </Flex>
              {totalEmpresas > 0 && (
                <Text
                  fontSize="xs"
                  color="teal.600"
                  fontWeight="semibold"
                  position="absolute"
                  bottom={2}
                  right={3}
                >
                  {porcentagemPresumido}%
                </Text>
              )}
            </>
          )}
        </CardBody>
      </Card>
    </Flex>
  );
}
